import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface TeamMember {
	id: number;
	name: string;
	title: string;
	description: string;
	image: string;
	image_url: string;
	order: number;
	is_active: boolean;
}

export interface ApiResponse<T> {
	status: boolean;
	data: T;
	message?: string;
}

@Injectable({
	providedIn: 'root',
})
export class TeamMemberService {
	private apiUrl = environment.apiUrl;

	constructor(private http: HttpClient) {}

	// Public
	getActive(): Observable<ApiResponse<TeamMember[]>> {
		return this.http.get<ApiResponse<TeamMember[]>>(`${this.apiUrl}/public/team-members`);
	}

	// Admin
	getAll(): Observable<ApiResponse<TeamMember[]>> {
		return this.http.get<ApiResponse<TeamMember[]>>(`${this.apiUrl}/admin/team-members`);
	}

	get(id: number): Observable<ApiResponse<TeamMember>> {
		return this.http.get<ApiResponse<TeamMember>>(`${this.apiUrl}/admin/team-members/${id}`);
	}

	create(data: FormData): Observable<ApiResponse<TeamMember>> {
		return this.http.post<ApiResponse<TeamMember>>(`${this.apiUrl}/admin/team-members`, data);
	}

	update(id: number, data: FormData): Observable<ApiResponse<TeamMember>> {
		return this.http.post<ApiResponse<TeamMember>>(`${this.apiUrl}/admin/team-members/${id}`, data);
	}

	delete(id: number): Observable<ApiResponse<null>> {
		return this.http.delete<ApiResponse<null>>(`${this.apiUrl}/admin/team-members/${id}`);
	}

	reorder(items: { id: number; order: number }[]): Observable<ApiResponse<null>> {
		return this.http.post<ApiResponse<null>>(`${this.apiUrl}/admin/team-members-reorder`, { items });
	}
}
